// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-row th {\n    position: relative;\n    background-color: #3A3F44 !important;\n    z-index: 5;\n}\n", ""]);
// Exports
module.exports = exports;
